export const GET_EMAIL = "GET_EMAIL";
export const GET_CODE = "GET_CODE";
export const GET_PASSWORD = "GET_PASSWORD";
